import { svg } from "../svg";

// The exported name is retained because it is part of the shared component API.
export const BitwardenIcon = svg`
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="5" class="tw-fill-brand" />
  <path d="M5 14V6h2.25l2.75 4.6L12.75 6H15v8h-2V9.2l-2.15 3.55h-1.7L7 9.2V14H5Z" class="tw-fill-text-alt2" />
</svg>
`;
